/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Add_Your_First_JobInputs */

const en_jobs_add_your_first_job = /** @type {(inputs: Jobs_Add_Your_First_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add your first job`)
};

const de_jobs_add_your_first_job = /** @type {(inputs: Jobs_Add_Your_First_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine erste Stelle hinzufügen`)
};

const fr_jobs_add_your_first_job = /** @type {(inputs: Jobs_Add_Your_First_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter ton premier emploi`)
};

const es_jobs_add_your_first_job = /** @type {(inputs: Jobs_Add_Your_First_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir su primer empleo`)
};

const it_jobs_add_your_first_job = /** @type {(inputs: Jobs_Add_Your_First_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi il tuo primo lavoro`)
};

const nl_jobs_add_your_first_job = /** @type {(inputs: Jobs_Add_Your_First_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg je eerste baan toe`)
};

const pl_jobs_add_your_first_job = /** @type {(inputs: Jobs_Add_Your_First_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj swoją pierwszą ofertę pracy`)
};

const fi_jobs_add_your_first_job = /** @type {(inputs: Jobs_Add_Your_First_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää ensimmäinen työpaikkasi`)
};

const da_jobs_add_your_first_job = /** @type {(inputs: Jobs_Add_Your_First_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj dit første job`)
};

const sv_jobs_add_your_first_job = /** @type {(inputs: Jobs_Add_Your_First_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till ditt första jobb`)
};

/**
* | output |
* | --- |
* | "Add your first job" |
*
* @param {Jobs_Add_Your_First_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_add_your_first_job = /** @type {((inputs?: Jobs_Add_Your_First_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Add_Your_First_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_add_your_first_job(inputs)
	if (locale === "fr") return fr_jobs_add_your_first_job(inputs)
	if (locale === "es") return es_jobs_add_your_first_job(inputs)
	if (locale === "it") return it_jobs_add_your_first_job(inputs)
	if (locale === "nl") return nl_jobs_add_your_first_job(inputs)
	if (locale === "pl") return pl_jobs_add_your_first_job(inputs)
	if (locale === "fi") return fi_jobs_add_your_first_job(inputs)
	if (locale === "da") return da_jobs_add_your_first_job(inputs)
	if (locale === "sv") return sv_jobs_add_your_first_job(inputs)
	return en_jobs_add_your_first_job(inputs)
});